"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getMapPoligonsFromUnknown_1 = require("./getMapPoligonsFromUnknown");
const isPointInsidePolygon_1 = __importDefault(require("./isPointInsidePolygon"));
const mapPolygonCheckIfCoordinatesAreInside = ({ latitude, longitude, polygon, }) => {
    const points = (0, getMapPoligonsFromUnknown_1.getMapPoligonCoordinatesFromUnknown)(polygon)
        .reduce((accum, data) => ([
        ...accum,
        [data.latitude, data.longitude],
    ]), []);
    return (0, isPointInsidePolygon_1.default)(points, [latitude, longitude]);
};
exports.default = mapPolygonCheckIfCoordinatesAreInside;
